<template>
  <div :class="$style.yybLogin">
    <Button type="primary" :class="$style.qqBtn" @click="toLogin(1)">
      <i class="iconfont yw-qq"></i>
      <span>QQ登录</span>
    </Button>
    <Button type="primary" :class="$style.wxBtn" @click="toLogin(2)">
      <i class="iconfont yw-wx"></i>
      <span>微信登录</span>
    </Button>
  </div>
</template>

<script>
import { Button } from 'vant';
import { yybLogin } from "@/bridge/AppJsBridge.js";

export default {
  name: '',
  data () {
    return {
    };
  },
  components: {
    Button
  },
  methods: {
    toLogin(type) {
      yybLogin(type);
    }
  }
}
</script>

<style lang="scss" module>
.yybLogin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 1.6rem 0;
  border-radius: .05rem;
  font-size: .15rem;
  text-align: center;
  z-index: 100;
  .qqBtn,.wxBtn {
    display: block;
    margin: .3rem auto;
    width: 5rem;
    height: .8rem;
    line-height: .8rem;
    border-radius: .8rem;  
    border: none;
    :global {
      .van-button__text {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .iconfont {
        margin-right: 5px;
      }
    }
  }
  .qqBtn {
    margin-bottom: .4rem;
    background: rgb(59, 190, 216);
  }
}
</style>
